import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { isEqual } from 'lodash';
import { NavBar } from '@components';

class PrivateRoute extends PureComponent {
	componentDidMount() {
		const { privateProps: { setRouteDetails }, computedMatch } = this.props;
		setRouteDetails(computedMatch);
	}

	UNSAFE_componentWillReceiveProps = ({ privateProps : { setRouteDetails }, computedMatch }) => {
		const { privateProps : lastPrivateProps } = this.props;
		if (!isEqual(computedMatch, lastPrivateProps.computedMatch)) setRouteDetails(computedMatch);
	}

	render() {
		const {
			component : Component,
			privateProps : { isAuthenticated },
			exact,
			path,
			showNavBar,
		} = this.props;

		return (
			<Route
				exact={exact}
				path={path}
				render={({ ...props }) => (
					<Choose>
						<When condition={isAuthenticated}>
							<Fragment>
								<If condition={showNavBar}>
									<NavBar
										active={props.location.pathname}
									/>
								</If>
								<div id="app-content">
									<Component {...props /* eslint-disable-line react/jsx-props-no-spreading */} />
								</div>
							</Fragment>
						</When>
						<Otherwise>
							<Redirect
								to={{
									pathname : '/login',
									state    : { from : props.location },
								}}
							/>
						</Otherwise>
					</Choose>
				)}
			/>
		);
	}
}

PrivateRoute.propTypes = {
	privateProps : PropTypes.shape({
		isAuthenticated : PropTypes.bool,
		setRouteDetails : PropTypes.func,
	}).isRequired,
	component     : PropTypes.func.isRequired,
	computedMatch : PropTypes.any,
	exact         : PropTypes.bool,
	path          : PropTypes.string,
	showNavBar    : PropTypes.bool,
};

PrivateRoute.defaultProps = {
	computedMatch : undefined,
	exact         : false,
	path          : '',
	showNavBar    : true,
};

export default PrivateRoute;
